export enum PublishKind {
  isSeminar,
  isTemplate,
}
